import React from 'react';
import { compose, withState } from 'recompose';
import styled from '@emotion/styled';
import cn from 'classnames';

import { track } from '../../common/tracking-utils';
import { qaSel, omitProps } from '../../common/utils';
import { UnreadMarker } from '../unread-marker';

const trackClick = type => () => type && track(type);

const hidden = R.pipe(
  R.flip(R.contains),
  R.any(R.__, ['c-challenges', 'c-activity_feed', 'c-notifications'])
);

const applyIndent = props => props.indentLevel && `padding-left: ${15 + props.indentLevel * 25}px;`;

export const LinkContainer = styled(({ className, ...props }) => (
  <ul role="menu" className={cn('c-link-container', className)}{...props}>
    {props.children}
  </ul>))`
  padding: 15px 0;
  margin: 0;
  list-style: none;
`;

export const Link = styled(omitProps(['isActive', 'indentLevel'])(({ className, children, ...rest }) => (
  <a className={cn(className, 'c-link')}{...rest}>{children}</a>
)))`
  display: block;
  padding: 7px 30px 7px 15px;
  ${applyIndent}
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: ${props => props.theme.fonts.size[3]}px;
  ${props => props.selected && 'font-weight: bold;'}
  color: ${props => props.selected ? props.theme.colors.primary[0] : props.theme.colors.neutral[1]};
  &:visited {
    color: ${props => props.selected ? props.theme.colors.primary[0] : props.theme.colors.neutral[1]};
  }
  &:hover, &:focus, &:active {
    text-decoration: none;
  }
  @media (min-width: 769px) {
    padding: 3px 30px 3px 15px;
    ${applyIndent}
    font-size: ${props => props.theme.fonts.size[2]}px;
    &:hover, &:focus, &:active {
      background-color: ${props => props.theme.colors.neutral[5]};
      color: ${props => props.theme.colors.primary[0]};
    }
  }
  @media (max-width: 768px) {
    ${props => props.isActive && `background-color: ${props.theme.colors.neutral[5]};`}
    ${props => props.isActive && `color: ${props.theme.colors.primary[0]};`}
  }
`;

const ListItem = styled('li')`
  margin: 0;
  padding: 0;
  border: 0;
  display: ${props => hidden(props.className) ? 'none' : 'block'};
`;

const Label = styled('span')`
  position: relative;
`;

const StyledUnreadMarker = styled(UnreadMarker)`
  right: -5px;
`;

const Links = compose(
  withState('activeLink', 'setActiveLink', '')
)(({ items, showMessagesNotification, className, activeLink, setActiveLink }) => (
  <LinkContainer className={className} onTouchMove={() => setActiveLink('')}>
    {items.map((item, index) => <ListItem
      className={`c-nav-item c-${item.type}`}
      key={item.type + index}
      role="menuitem">
      <Link
        data-qa={qaSel(`more-menu-link-${item.type}`)}
        href={item.path}
        isActive={activeLink === item.path}
        onClick={() => {
          trackClick(item.track);
          setActiveLink(item.path);
          item.onClick && item.onClick();
        }}
        onBlur={() => setActiveLink('')}
        aria-label={item.title} >
        <Label>
          {item.label}
          {item.type === 'messages' && showMessagesNotification && <StyledUnreadMarker show={showMessagesNotification} />}
        </Label>
      </Link>
    </ListItem>
    )}
  </LinkContainer>
));

export default Links;
